<template>
  <div>
    <div class="container_top_img">
      <img src="../../assets/img/new/researchBanner.png" alt="logo">
    </div>
    <div class="my_container">
      <div class="research_nav_ul">
          <div v-for="(item, index) in list" :key="item.research_id" class="research_nav_item">
            <div class="research_nav_top">
              <i></i>
              <img :src="item.bg_img" alt="封面">
              <dl>
                <dt>{{item.research_name}}</dt>
                <dd>{{item.research_en_name}}</dd>
              </dl>
            </div>
            <div class="research_nav_content">
              {{item.content | strFilter}}
              <router-link :to="{ path: '/researchIntroduce', query: {id: item.research_id, type: 'introduce'} }">[详情]</router-link>
            </div>
            <div class="research_nav_bottom">
              {{item.num}}成员
              <div class="research_nav_bottom_btn">
                <button v-if="item.is_join === 0" class="greenglga_btn" @click="join(item.research_id, index)">
                  <i class="add">+</i>
                  <span>申请加入</span>
                </button>
                <button v-if="item.is_join === 1"
                class="greenglga_follow_btn"
                @click="jump(item.research_id)">
                  进入研究院
                </button>
                <p v-if="item.is_join === 2">已申请</p>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [] // 研究院列表
    }
  },
  filters: {
    strFilter: function (value) {
      console.log(value)
      let str = ''
      if (value.length > 75) {
        str = value.substr(0, 75) + '...'
      } else {
        str = value
      }
      return str
    }
  },
  created () {
    this.getNavList()
  },
  methods: {
    // 获取研究院列表
    getNavList () {
      const vueThat = this
      vueThat.myApi.getResearchList().then((res) => {
        if (res.data.code === 200) {
          vueThat.list = res.data.data
        }
      })
    },
    // 跳转
    jump (rid) {
      this.$router.push({ path: '/research/:id', query: { id: rid } })
    },
    // 加入研究院
    join (id, index) {
      const vueThat = this
      vueThat.myApi.joinResearch({ research_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.list[index].is_join = 2
          vueThat.$message({
            message: '申请已成功提交，请耐心等待...',
            type: 'success'
          })
        } else {
          vueThat.$message({
            message: '申请提交失败，请刷新后重试',
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
